/**
 * @fileoverview gRPC-Web generated client stub for pb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.pb = require('./dashboard_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.AvalancheClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.AvalanchePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!proto.pb.AvalancheClient} The delegate callback based client
   */
  this.delegateClient_ = new proto.pb.AvalancheClient(
      hostname, credentials, options);

};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pb.Cluster,
 *   !proto.pb.Cluster>}
 */
const methodInfo_Avalanche_ListClusters = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pb.Cluster,
  /** @param {!proto.pb.Cluster} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.Cluster.deserializeBinary
);


/**
 * @param {!proto.pb.Cluster} request The request proto
 * @param {!Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Cluster>}
 *     The XHR Node Readable Stream
 */
proto.pb.AvalancheClient.prototype.listClusters =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.Avalanche/ListClusters',
      request,
      metadata,
      methodInfo_Avalanche_ListClusters);
};


/**
 * @param {!proto.pb.Cluster} request The request proto
 * @param {!Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Cluster>}
 *     The XHR Node Readable Stream
 */
proto.pb.AvalanchePromiseClient.prototype.listClusters =
    function(request, metadata) {
  return this.delegateClient_.client_.serverStreaming(this.delegateClient_.hostname_ +
      '/pb.Avalanche/ListClusters',
      request,
      metadata,
      methodInfo_Avalanche_ListClusters);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pb.Namespace,
 *   !proto.pb.Namespace>}
 */
const methodInfo_Avalanche_ListNamespaces = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pb.Namespace,
  /** @param {!proto.pb.Namespace} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.Namespace.deserializeBinary
);


/**
 * @param {!proto.pb.Namespace} request The request proto
 * @param {!Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Namespace>}
 *     The XHR Node Readable Stream
 */
proto.pb.AvalancheClient.prototype.listNamespaces =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.Avalanche/ListNamespaces',
      request,
      metadata,
      methodInfo_Avalanche_ListNamespaces);
};


/**
 * @param {!proto.pb.Namespace} request The request proto
 * @param {!Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Namespace>}
 *     The XHR Node Readable Stream
 */
proto.pb.AvalanchePromiseClient.prototype.listNamespaces =
    function(request, metadata) {
  return this.delegateClient_.client_.serverStreaming(this.delegateClient_.hostname_ +
      '/pb.Avalanche/ListNamespaces',
      request,
      metadata,
      methodInfo_Avalanche_ListNamespaces);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pb.NodePool,
 *   !proto.pb.NodePool>}
 */
const methodInfo_Avalanche_ListNodePools = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pb.NodePool,
  /** @param {!proto.pb.NodePool} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.NodePool.deserializeBinary
);


/**
 * @param {!proto.pb.NodePool} request The request proto
 * @param {!Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.NodePool>}
 *     The XHR Node Readable Stream
 */
proto.pb.AvalancheClient.prototype.listNodePools =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.Avalanche/ListNodePools',
      request,
      metadata,
      methodInfo_Avalanche_ListNodePools);
};


/**
 * @param {!proto.pb.NodePool} request The request proto
 * @param {!Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.NodePool>}
 *     The XHR Node Readable Stream
 */
proto.pb.AvalanchePromiseClient.prototype.listNodePools =
    function(request, metadata) {
  return this.delegateClient_.client_.serverStreaming(this.delegateClient_.hostname_ +
      '/pb.Avalanche/ListNodePools',
      request,
      metadata,
      methodInfo_Avalanche_ListNodePools);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pb.Namespace,
 *   !proto.pb.App>}
 */
const methodInfo_Avalanche_WatchApps = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pb.App,
  /** @param {!proto.pb.Namespace} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.App.deserializeBinary
);


/**
 * @param {!proto.pb.Namespace} request The request proto
 * @param {!Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.App>}
 *     The XHR Node Readable Stream
 */
proto.pb.AvalancheClient.prototype.watchApps =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.Avalanche/WatchApps',
      request,
      metadata,
      methodInfo_Avalanche_WatchApps);
};


/**
 * @param {!proto.pb.Namespace} request The request proto
 * @param {!Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.App>}
 *     The XHR Node Readable Stream
 */
proto.pb.AvalanchePromiseClient.prototype.watchApps =
    function(request, metadata) {
  return this.delegateClient_.client_.serverStreaming(this.delegateClient_.hostname_ +
      '/pb.Avalanche/WatchApps',
      request,
      metadata,
      methodInfo_Avalanche_WatchApps);
};


module.exports = proto.pb;

